import { render, staticRenderFns } from "./salvageDetails.vue?vue&type=template&id=e098237a&scoped=true"
import script from "./salvageDetails.vue?vue&type=script&lang=js"
export * from "./salvageDetails.vue?vue&type=script&lang=js"
import style0 from "./salvageDetails.vue?vue&type=style&index=0&id=e098237a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e098237a",
  null
  
)

export default component.exports